<template>
  <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
    viewBox="0 0 200 200" enable-background="new 0 0 200 200" xml:space="preserve">
  <g>
    <g>
      <path class="color" fill="#F45B5B" d="M145.171,144.219c-5.531,0-10.014-4.481-10.014-10.013c0-21.057-8.982-30.04-30.039-30.04h-28
        l8.834,10.095c3.641,4.162,3.22,10.489-0.942,14.13c-4.163,3.641-10.486,3.217-14.13-0.942l-23.332-26.666
        c-1.562-1.767-2.51-4.087-2.51-6.63c0-2.542,0.948-4.863,2.51-6.63L70.88,60.856c3.644-4.162,9.967-4.586,14.13-0.942
        c4.162,3.645,4.583,9.968,0.942,14.13L77.118,84.14h28c32.285,0,50.066,17.78,50.066,50.066
        C155.185,139.737,150.702,144.219,145.171,144.219z"/>
    </g>
  </g>
  </svg>

</template>

<script>
export default {
  name: 'ReplyIcon'
}
</script>
